import { connect } from "react-redux";
import SampleComments from "./SampleComments";
import { handleChangeSampleCommentsFilter, getCommentsAndGist } from "../../../../../../../../redux/actions";


const mapStateToProps = (state) => ({

    fetchCommentsAndGistApi: state.BenchmarkFilteringReducer.fetchCommentsAndGistApi,
    fetchBenchmarkTaxonomyApi: state.BenchmarkFilteringReducer.fetchBenchmarkTaxonomyApi,
    sampleCommentsFilters: state.BenchmarkFilteringReducer.sampleCommentsFilters,
    benchmarkFiltersAnalysis: state.BenchmarkFilteringReducer.benchmarkFiltersAnalysis

});

const mapDispatchToProps = (dispatch) => ({

    handleChangeSampleCommentsFilter: (payload) => dispatch(handleChangeSampleCommentsFilter(payload)),
    getCommentsAndGist: (payload, cb, scope) => dispatch(getCommentsAndGist(payload, cb, scope))

});

export default connect(mapStateToProps, mapDispatchToProps)(SampleComments);
